define(function (require, exports, module) {
    var Logger = require('app-console/app-console');

    return new Logger({ ns: 'GDC' });
});
